export default {"src":"/_next/static/media/tooltip_questionmark.767dcfe9.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};